// removed by extract-text-webpack-plugin
module.exports = {"container":"typeahead__container___2Jko-","clear":"typeahead__clear___23_KS","footer":"typeahead__footer___3yG5a","label":"typeahead__label___1aQXq","suggest":"typeahead__suggest___3gAeS","icon":"typeahead__icon___3_Kb4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/typeahead.pcss
// module id = 228
// module chunks = 0